import { Capacitor } from "@capacitor/core";
import { InAppBrowser } from "@capacitor/inappbrowser";
import { apiReq } from "./apiReq";
import { ReqMethod } from "@larner.dev/req";

/**
 * Opens a URL in the system's external browser.
 * This is required for payment-related pages to comply with Apple App Store guidelines.
 *
 * On native platforms (iOS/Android), this will open the URL in the system browser
 * (Safari on iOS, Chrome/default browser on Android) with a transfer token to maintain authentication.
 *
 * On web, this opens in a new tab.
 *
 * @param path - The path to open (e.g., "/event/atlanta/123")
 */
export const openExternalUrl = async (path: string) => {
  const baseUrl =
    import.meta.env.VITE_WEB_URL || "https://www.greenflagdate.com";
  let fullUrl = path.startsWith("http") ? path : `${baseUrl}${path}`;

  if (Capacitor.isNativePlatform()) {
    try {
      // Request a transfer token from the backend
      const response = await apiReq.standardRequest<{ transferToken: string }>(
        "/user/transfer-token",
        ReqMethod.POST
      );

      if (response?.transferToken) {
        // Append transfer token to URL
        const separator = fullUrl.includes("?") ? "&" : "?";
        fullUrl = `${fullUrl}${separator}tt=${encodeURIComponent(response.transferToken)}`;
      }
    } catch (error) {
      console.error("Failed to generate transfer token:", error);
      // Continue without token - user will need to log in manually
    }

    InAppBrowser.openInExternalBrowser({
      url: fullUrl,
    });
  } else {
    // On web, open in new tab
    window.open(fullUrl, "_blank");
  }
};
